import { Vehicle } from '../../models/vehicle.interface';

export class VehicleState {
  vehicles: Vehicle[] = [];
}
